import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import {
  routerReducer,
  StoreRouterConnectingModule,
  RouterStateSerializer,
} from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { MatSnackBarModule as MatSnackBarModule } from '@angular/material/snack-bar';
import { metaReducers } from './metaReducers';
import { environment } from '../../environments/environment';
import { CustomSerializer } from './router-store-serializer';
import { EventLogStoreModule } from './event-log-store';
import { UserStoreModule } from './user-store';
import { SharedStoreModule } from './shared-store';

@NgModule({
  imports: [
    CommonModule,
    MatSnackBarModule,
    EventLogStoreModule,
    UserStoreModule,
    SharedStoreModule,

    StoreModule.forRoot(
      {
        router: routerReducer,
      },
      { metaReducers }
    ),
    StoreRouterConnectingModule.forRoot(),
    EffectsModule.forRoot([]),
    environment.production
      ? []
      : StoreDevtoolsModule.instrument({
          maxAge: 25, // Retains last 25 states
        }),
  ],
  providers: [{ provide: RouterStateSerializer, useClass: CustomSerializer }],
  declarations: [],
})
export class RootStoreModule {}
